'use client';

import { prefix } from '@util/imagePrefix';
import { ShopTireCard } from './ShopTireCard';

const tires = [
  {
    name: 'Front Tire',
    description: 'Precision Steering & Maximum Control',
    type: 'individual',
    keyword: 'front tire',
  },
  {
    name: 'Rear Tire',
    description: 'Superior Grip for Ultimate Traction',
    type: 'individual',
    keyword: 'rear tire',
  },
  {
    name: 'Sets',
    description: 'Complete Performance for Any Terrain',
    type: 'set',
    keyword: 'tire set',
  },
];

export default function ShopTires({ rideType = '' }: { rideType?: string }) {
  return (
    <div className="bg-[#F6F6F6] py-32">
      <div className="flex w-full flex-col gap-y-32 sm:mx-auto sm:max-w-[150rem]">
        <div className="flex w-full justify-center">
          <h1 className="text-[3.7rem] font-bold capitalize text-black">
            Shop {rideType} Tires
          </h1>
        </div>

        <div className="flex w-full flex-col items-center gap-x-4 sm:flex-row">
          {tires.map((tire) => {
            const isSet = tire.type === 'set';
            const imageSrc = `${prefix}/assets/template-${
              isSet ? 'tire' : 'individual-tire'
            }_1920x2560.png`;

            return (
              <ShopTireCard
                key={tire.name}
                image={imageSrc}
                name={tire.name}
                description={tire.description ?? ''}
                url={`/search?keyword=${encodeURIComponent(tire.keyword)}`}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
